"use client";
import {
  __spreadValues
} from "../../../chunk-MMUBH76A.js";
import { create } from "zustand";
import { getActions } from "./actions.js";
import { AuthLayout } from "../../types/modalProps.js";
const DEFAULT_THEME = {
  isDark: false,
  logo: void 0,
  appName: void 0,
  bareModal: false,
  embeddedModal: false,
  oAuthLogoVariant: void 0,
  authLayout: [AuthLayout.AUTH_FULL, AuthLayout.EXTERNAL_FULL],
  hideWallets: false
};
const useThemeStore = create((set, get) => __spreadValues(__spreadValues({}, DEFAULT_THEME), getActions(set, get)));
export {
  useThemeStore
};
